import FilePickerAction from '../store/schema/FilePickerAction';
import FilePickerViewState from '../store/schema/FilePickerViewState';
import FileProviderItemViewState from '../store/schema/FileProviderItemViewState';
import { action } from 'satcheljs/lib/legacy';
import { FileProviderViewState } from 'owa-fileprovider-store';
import { getFileProviderInfo } from '../utils/fileProviderInfo';
import {
    shouldAllowInsertAction,
    shouldDisableAttachButton,
    shouldDisableShareButton,
} from '../utils/shouldDisableActionButton';

function deleteFromArray(array: any[], item: any) {
    const index = array.indexOf(item);

    if (index !== -1) {
        array.splice(index, 1);
    }
}

function internalUpdateSupportedActions(
    possibleActions: FilePickerAction[],
    messages: string[],
    items: FileProviderItemViewState[] | File[],
    maxAllowedLocalFileSize: number,
    viewState: FilePickerViewState,
    fileProviderName: string
) {
    const disableAttachButtonInfo = shouldDisableAttachButton(
        items,
        fileProviderName,
        maxAllowedLocalFileSize
    );
    if (disableAttachButtonInfo.shouldDisable) {
        deleteFromArray(possibleActions, FilePickerAction.Attach);
    }

    if (disableAttachButtonInfo.message !== null) {
        messages = messages.concat(disableAttachButtonInfo.message);
    }

    if (shouldDisableShareButton(items)) {
        deleteFromArray(possibleActions, FilePickerAction.Share);
    }
    viewState.supportedActionsMessages = messages;
    viewState.supportedActions = possibleActions;
}

export const updateSupportedFilePickerActionsForProviderFiles = action(
    'updateSupportedFilePickerActionsForProviderFiles'
)(function updateSupportedFilePickerActionsForProviderFiles(
    items: FileProviderItemViewState[],
    maxAllowedLocalFileSize: number,
    selectedFileProvider: FileProviderViewState,
    viewState: FilePickerViewState
) {
    if (items.length === 0) {
        viewState.supportedActions = [];
        return;
    }

    // Update the supported actions based on the provider
    const providerInfo = getFileProviderInfo(selectedFileProvider.type);
    const supportedProviderActions = providerInfo.getItemsSupportedActions(
        items as FileProviderItemViewState[],
        selectedFileProvider.allowFolderSharing,
        selectedFileProvider.name
    );
    internalUpdateSupportedActions(
        supportedProviderActions.actions,
        supportedProviderActions.messages,
        items,
        maxAllowedLocalFileSize,
        viewState,
        selectedFileProvider.name
    );
});

export const updateSupportedFilePickerActionsForLocalFiles = action(
    'updateSupportedFilePickerActionsForLocalFiles'
)(function updateSupportedFilePickerActionsForLocalFiles(
    items: File[],
    maxAllowedLocalFileSize: number,
    viewState: FilePickerViewState
) {
    if (items.length === 0) {
        viewState.supportedActionsMessages = [];
        viewState.supportedActions = [];
        return;
    }

    const supportedActions = [FilePickerAction.Attach, FilePickerAction.Share];

    if (shouldAllowInsertAction(items)) {
        supportedActions.push(FilePickerAction.Insert);
    }

    internalUpdateSupportedActions(
        supportedActions,
        [],
        items,
        maxAllowedLocalFileSize,
        viewState,
        'OneDrive' /*TODO: Get default provider name here"*/
    );
});
